import React, { Component } from "react";
import { Button } from 'reactstrap';
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setError, setSuccess, setLoader } from "../../../actions/action-creators";
import moment from "moment";
import { Switch, TablePagination, Icon } from "@material-ui/core";
import InputFeild from "../../global/form/input";

const RETRYABLE_STATUS = [1, 4]; // Bank Details Missing, Failed

const fmtDate  = (v) => { const m = moment(v); return (v && m.isValid()) ? m.utcOffset("+05:30").format("Do MMM'YY") : "—"; };
const fmtINR   = (v) => v != null ? "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "—";
const orDash   = (v) => (v != null && v !== "") ? v : "—";

const PAYOUT_STATUS = {
    1: { label: "Bank Details Missing", bg: "#fff0f0", color: "#c0392b" },
    2: { label: "Processing",           bg: "#fff7e6", color: "#d46b08" },
    3: { label: "Processing",           bg: "#fff7e6", color: "#d46b08" },
    4: { label: "Failed",               bg: "#fff0f0", color: "#c0392b" },
    5: { label: "Paid",                 bg: "#e6f7ee", color: "#1a7a42" },
};
const statusBadge = (status) => {
    const cfg = PAYOUT_STATUS[status] || { label: "—", bg: "#f0f0f0", color: "#888" };
    return (
        <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
            {status === 5 && "✓ "}{cfg.label}
        </span>
    );
};

class UserPayouts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            payoutData: [],
            userMetaData: {},
            currentPage: 0,
            isEditPayoutStatus: false,
        };
    }

    componentDidMount() {
        this.showPayoutData();
        this.fetchUserMetaData();
    }

    fetchUserMetaData = async () => {
        store.dispatch(setLoader(true));
        try {
            let resp = await ApiEndpoints.User.fetchUserMetaData({ user_id: this.props.user_id });
            this.setState({ userMetaData: resp.data.data[0] || {} });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    showPayoutData = async () => {
        store.dispatch(setLoader(true));
        try {
            let resp = await ApiEndpoints.JobTaskPayment.fetchUserPayouts({ user_id: this.props.user_id });
            let payoutData = resp.data.data.sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
            this.setState({ payoutData });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    retryPayoutData = async (payout_data_id) => {
        if (!window.confirm("Are you sure?")) return;
        store.dispatch(setLoader(true));
        let { payoutData } = this.state;
        try {
            let resp = await ApiEndpoints.JobTaskPayment.retryPayoutData({ payout_data_id });
            payoutData = payoutData.map(data => {
                if (data.payout_data_id === payout_data_id) data = { ...data, ...(resp.data.data || {}) };
                return data;
            });
            this.setState({ payoutData });
            store.dispatch(setSuccess({ show: true, message: "Retry Payout request submitted successfully" }));
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    updatePayoutStatus = async () => {
        store.dispatch(setLoader(true));
        let { userMetaData, isEditPayoutStatus } = this.state;
        try {
            await ApiEndpoints.User.updateUserMetaData({
                user_id: this.props.user_id,
                payout_status: userMetaData.payout_status,
                payout_remark: isEditPayoutStatus.remark || "",
            });
            this.setState({ isEditPayoutStatus: false });
        } catch (e) {
            store.dispatch(setError({ show: true, message: e.response ? e.response.data.message : e.toString() }));
        }
        store.dispatch(setLoader(false));
    };

    render() {
        let { payoutData, userMetaData, isEditPayoutStatus, currentPage } = this.state;
        const isHold = userMetaData.payout_status === 2;
        const page   = payoutData.slice(currentPage * 10, currentPage * 10 + 10);

        return (
            <div>
                {/* ── Payout Status Card ─────────────────────────────── */}
                {!!userMetaData.payout_status && (
                    <div style={S.statusCard}>
                        <div style={S.statusLeft}>
                            <span style={{ ...S.statusDot, background: isHold ? "#c0392b" : "#27ae60" }} />
                            <span style={S.statusLabel}>Payout Status</span>
                            <span style={{ ...S.statusPill, background: isHold ? "#fff0f0" : "#e6f7ee", color: isHold ? "#c0392b" : "#1a7a42" }}>
                                {isHold ? "On Hold" : "Active"}
                            </span>
                            {userMetaData.payout_remark && (
                                <span style={S.statusRemark}>{userMetaData.payout_remark}</span>
                            )}
                        </div>
                        <div style={S.statusRight}>
                            <Switch
                                size="small"
                                color="default"
                                style={{ color: isHold ? "#c0392b" : "#27ae60" }}
                                checked={!isHold}
                                onClick={(e) => {
                                    userMetaData.payout_status = e.target.checked ? 1 : 2;
                                    this.setState({ isEditPayoutStatus: {}, userMetaData });
                                }}
                            />
                            {!!isEditPayoutStatus && (
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    {isHold && (
                                        <InputFeild
                                            style={{ fontSize: 12, margin: 0, width: 180 }}
                                            placeholder="Hold reason (optional)"
                                            value={isEditPayoutStatus.remark || ""}
                                            onChange={(e) => {
                                                isEditPayoutStatus.remark = e.target.value;
                                                this.setState({ isEditPayoutStatus });
                                            }}
                                        />
                                    )}
                                    <Button size="sm" color="dark" style={{ fontSize: 12 }} onClick={this.updatePayoutStatus}>Save</Button>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* ── Payout History ─────────────────────────────────── */}
                <div style={S.sectionTitle}>Payout History</div>

                {payoutData.length === 0 ? (
                    <div style={S.emptyState}>No payout data found.</div>
                ) : (
                    <>
                        <div style={S.tableWrapper}>
                            <table style={S.table}>
                                <thead>
                                    <tr style={S.tHead}>
                                        <th style={S.th}>Payout Title</th>
                                        <th style={S.th}>Amount</th>
                                        <th style={S.th}>Status</th>
                                        <th style={S.th}>Date</th>
                                        <th style={S.th}>Credited On</th>
                                        <th style={S.th}>Bank UTR</th>
                                        <th style={S.th}>Bank Req ID</th>
                                        <th style={S.th}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {page.map((payout, i) => (
                                        <tr key={i} style={S.tRow}>
                                            <td style={S.td}>
                                                <span style={{ fontWeight: 700, color: "#1a1a1a" }}>
                                                    {payout.Payout ? payout.Payout.payout_title : "—"}
                                                </span>
                                            </td>
                                            <td style={{ ...S.td, fontWeight: 700 }}>
                                                {fmtINR(payout.amount)}
                                            </td>
                                            <td style={S.td}>
                                                {statusBadge(payout.status)}
                                            </td>
                                            <td style={{ ...S.td, whiteSpace: "nowrap", color: "#555" }}>
                                                {fmtDate(payout.created_on)}
                                            </td>
                                            <td style={{ ...S.td, whiteSpace: "nowrap", color: "#555" }}>
                                                {fmtDate(payout.amount_credited_on)}
                                            </td>
                                            <td style={{ ...S.td, fontSize: 12, color: "#555", fontFamily: "monospace" }}>
                                                {orDash(payout.bank_utr)}
                                            </td>
                                            <td style={{ ...S.td, fontSize: 12, color: "#555", fontFamily: "monospace" }}>
                                                {orDash(payout.bank_req_id)}
                                            </td>
                                            <td style={S.td}>
                                                {RETRYABLE_STATUS.includes(payout.status) &&
                                                    <Icon onClick={() => this.retryPayoutData(payout.payout_data_id)} style={{ cursor: "pointer", fontSize: 18, color: "#555" }} title="Retry Payout">refresh</Icon>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <TablePagination
                            rowsPerPageOptions={[10]}
                            component="div"
                            count={payoutData.length}
                            rowsPerPage={10}
                            page={currentPage}
                            onPageChange={(_, p) => this.setState({ currentPage: p })}
                        />
                    </>
                )}
            </div>
        );
    }
}

const S = {
    statusCard: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        border: "1px solid #e8e8e8",
        borderRadius: 12,
        padding: "14px 20px",
        background: "#fff",
        marginBottom: 22,
    },
    statusLeft:  { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
    statusRight: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
    statusDot:   { width: 10, height: 10, borderRadius: "50%", flexShrink: 0 },
    statusLabel: { fontSize: 15, fontWeight: 700, color: "#1a1a1a" },
    statusPill:  { borderRadius: 999, padding: "3px 14px", fontSize: 13, fontWeight: 600 },
    statusRemark:{ fontSize: 12, color: "#888" },

    sectionTitle: { fontSize: 14, fontWeight: 700, color: "#1a1a1a", marginBottom: 12 },

    tableWrapper: { border: "1px solid #e8e8e8", borderRadius: 10, overflow: "auto" },
    table:   { width: "100%", borderCollapse: "collapse", fontSize: 13 },
    tHead:   { background: "#f5f5f5" },
    th:      { padding: "10px 14px", textAlign: "left", fontWeight: 600, color: "#555", borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap" },
    tRow:    { borderBottom: "1px solid #f0f0f0" },
    td:      { padding: "11px 14px", color: "#333", verticalAlign: "middle" },
    emptyState: { padding: "40px 20px", textAlign: "center", color: "#aaa", fontSize: 14 },
};

export default UserPayouts;
